// The admin page's list, one page at a time, newest first (GetAssessments with ?limit=).
// The totals at the top always count every record, whatever is loaded or filtered.

export const PAGE_SIZE = 200;

export const EMPTY_TOTALS = { records: 0, completed: 0, drafts: 0, no_pdf: 0, clients: 0 };

// Query parameters for one page. status: all / completed / draft / nopdf; search: part of a name.
export function pageParams({ offset = 0, status = "all", search = "" } = {}) {
  const params = { limit: PAGE_SIZE, offset };
  if (status && status !== "all") params.status = status;
  const q = (search || "").trim();
  if (q) params.q = q;
  return params;
}

// Parameters for every record of one client (Delete all, Regenerate all).
export function clientParams(name) {
  return { name };
}

// Read a page reply. An older reply that is a plain list counts as everything.
export function readPage(data) {
  if (Array.isArray(data)) {
    return {
      items: data,
      totals: {
        records: data.length,
        completed: data.filter((a) => a.status !== "draft").length,
        drafts: data.filter((a) => a.status === "draft").length,
        no_pdf: data.filter((a) => a.status !== "draft" && !a.pdf_path).length,
        clients: new Set(data.map((a) => a.name || "Unknown")).size,
      },
      matching: data.length,
      hasMore: false,
    };
  }
  const d = data || {};
  return {
    items: d.items || [],
    totals: { ...EMPTY_TOTALS, ...(d.totals || {}) },
    matching: d.matching || 0,
    hasMore: !!d.has_more,
  };
}

// Add the next page to what is already shown, without showing any record twice.
export function appendPage(shown, next) {
  const seen = new Set(shown.map((a) => a.id));
  return shown.concat(next.filter((a) => !a.id || !seen.has(a.id)));
}

// "Showing 200 of 1,240" under the list.
export function showingLine(shownCount, matching) {
  const fmt = (n) => Number(n || 0).toLocaleString("en-AU");
  return `Showing ${fmt(shownCount)} of ${fmt(matching)}`;
}
